<script>
import _map from 'lodash/map'
import _forEach from 'lodash/forEach'
import CustomCheckbox from '@components/custom-checkbox'

export default {
  components: { CustomCheckbox },
  props: {
    metrics: { type: Array, default: () => [] },
    colors: { type: Array, default: () => ['#243f92', '#11a0b0', '#11a0b0'] },
  },
  data() {
    return {
      metricInfos: [
        '<b>STAAR Percentage at Masters Grade Level Standard</b> - The percentage of tests that met the Masters Grade Level performance standard.This indicator was part of determining the score for Index 3.',
        '<b>STAAR Percentage Met or Exceeded Progress</b> - The percentage of tests that met or exceeded the STAAR or ELL progress measure expectations.',
        '<b>STAAR Percentage Exceeded Progress</b> - The percentage of tests that exceeded the progress measure expectations.',
        '<b>Advanced/Dual Courses Taken</b> - The percentage of students who complete and receive credit for at least one advanced or dual-credit course.',
        '<b>TSIA</b> - Texas Success Initiative Assessment: The percentage of annual graduates who met the TSI criteria on the TSIA.'
      ],
    }
  },
  computed: {
    filterItemColors() {
      var colors = this.colors
      return _map(this.metrics, (val, index) => {
        return colors[index % colors.length]
      })
    },
    filterItemIds() {
      return _map(this.metrics, (val, index) => {
        return val.id
      })
    },
  },
  methods: {
    selectAll() {
      _forEach(this.metrics, item => {
        item.checked = true
      })
      this.$emit('selectAll')
    },
    selectNone() {
      _forEach(this.metrics, item => {
        item.checked = false
      })
      this.$emit('selectNone')
    },
    toggleCheckbox(index) {
      this.metrics[index].checked = !this.metrics[index].checked
      this.$emit('updateFooter')
    },
  },
}
</script>

<template>
  <v-list class="custom-metric">
    <v-subheader class="metirc-title">Categories
      <v-menu
        :close-on-content-click="false"
        :nudge-width="300"
        :max-width="300"
        offset-x
        class="info-btn"
      >
        <!-- <v-btn
          slot="activator"
          icon
          class="mt-0 mb-0 mr-0">
          <v-icon>info</v-icon>
        </v-btn> -->
        <v-card>
          <v-card-text
            class="metric-text"
            v-for="(item,index) in metricInfos"
            :key="index"
            v-html="item"
            />
        </v-card>
      </v-menu>
    </v-subheader>
    <li>
    <v-list-tile-content>
      <CustomCheckbox
        v-for="(item,index) in metrics"
        :data-id="filterItemIds[index]"
        :key="index"
        :label="item.label"
        :checked="item.checked"
        :disabled="item.disabled"
        :color="filterItemColors[index]"
        @click="toggleCheckbox(index)"
      />
    </v-list-tile-content>
    </li>
  </v-list>
</template>

<style scoped>

.metric-text {
  font-size: 12px !important;
  padding: 0px 16px 16px !important;
}

.metric-text:first-child {
  padding-top: 16px !important;
}

.metirc-title {
  font-weight: bolder;
  font-size: 16px;
  font-size: 1.25rem;
  color: #707070;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  margin-bottom: 5px;
  justify-content: space-between;
}
.metirc-title >>> .btn__content {
  color: #253e90;
}
.metirc-title >>> .btn__content::before {
  color: #0390c4;
  opacity: 0.5;
}
.info-btn :hover {
  cursor: pointer;
}
.a-select-color {
  color: rgba(0, 0, 0, 0.54);
}
.input-group label {
  height: 20px;
}
.custom-metric {
  position: relative;
}
.custom-metric >>> .list__tile {
  padding: 0px;
}
</style>
